import React from "react";
import * as BootstrapIcons from "react-bootstrap-icons";

// Components
import Magnetic from "../Magnetic/Magnetic";

// SCSS
import "./Tag.scss";

const Tag = ({ text, iconClass, link, setHoveredElement }) => {
  const IconComponent = BootstrapIcons[iconClass];

  return link ? (
    <Magnetic
      as="a"
      href={link}
      className="Tag"
      target="_blank"
      rel="noreferrer"
      setHoveredElement={setHoveredElement}
    >
      {IconComponent && <IconComponent className="Tag__Icon" />}
      <span className="Tag__Text">{text}</span>
    </Magnetic>
  ) : (
    <div className="Tag">
      {IconComponent && <IconComponent className="Tag__Icon" />}
      <span className="Tag__Text">{text}</span>
    </div>
  );
};

export default Tag;
